//Global keys
let locales = {
    notificationList_title: 'Notifiche',
    notificationList_buttonAllNotifications: 'Tutti',
    notificationList_buttonNotReadNotifications: 'Non visto',
    notificationList_buttonWatchAllNotifications: 'Vedi tutte le notifiche',
    notificationList_moreNotifications: 'Ci sono altre notifiche da vedere…',
};

export default locales;